import React from 'react'
import { Autocomplete, FormControl, FormHelperText, InputLabel, TextField, createFilterOptions } from '@mui/material';
import { Controller } from 'react-hook-form';
import Select, { Props as ReactSelectProps } from 'react-select';

const filter = createFilterOptions<any>();
interface SelectDropDownProps {
    label: string;
    options: any;
    onChange?: ReactSelectProps<any, true>['onChange'];
    placeholder?: string;
    selectedValues?: any;
    errors?: any;
    name: string;
    control: any;
    defaultValue?: any
}

const InputSelectControlWithSearch: React.FC<SelectDropDownProps> = (props) => {
    const { name, label, control, options, errors, onChange, placeholder, selectedValues, defaultValue } = props;
    // Remove local value state, use react-hook-form value

    return (
        <>
            <InputLabel>{label}</InputLabel>
            <FormControl error={Boolean(errors[name])}>

            <Controller
                render={({ field }) => (
                    <Autocomplete
                        options={options}
                        id="controlled-demo"
                        value={options.find((opt: { value: any; }) => opt.value === field.value) || null}
                        getOptionLabel={(option) => {
                            if (typeof option === 'string') {
                                return option;
                            }
                            if (option.inputValue) {
                                return option.inputValue;
                            }
                            return option.label;
                        }}
                        onChange={(_, newValue) => {
                            field.onChange(newValue ? newValue.value : "");
                        }}
                        filterOptions={(options, params) => {
                            const filtered = filter(options, params);
                            const { inputValue } = params;
                            const isExisting = options.some((option) => inputValue === option.label);
                            if (inputValue !== '' && !isExisting) {
                                filtered.push({
                                    value: inputValue,
                                    label: inputValue,
                                });
                            }
                            return filtered;
                        }}
                        freeSolo
                        renderInput={(params) => (
                            <TextField {...params} variant="outlined" />
                        )}
                    />
                )}
                name={name}
                control={control}
                defaultValue={selectedValues}
            />
            {errors && <FormHelperText>{errors[name]?.message}</FormHelperText>}
            </FormControl>
        </>
    )
}

export default InputSelectControlWithSearch